import { useRefreshCandidate } from "#candidate/redux/actions"
import { useCandidateRedux } from "#candidate/redux/slice"
import { candidateIdPut } from "#candidate/services/api"
import InputDateTime from "#common/input/InputDateTime"
import { DialogMaster } from "#core/components/dialog/Dialog"
import { useApiSend } from "#hooks/useApiSend"
import CheckBoxIcon from "@mui/icons-material/CheckBox"
import EditIcon from "@mui/icons-material/Edit"
import { Button, Stack } from "@mui/material"
import dayjs from "dayjs"
import { useCallback, useEffect, useState } from "react"

export const CandidateEditDateTime = ({ id, label, date }) => {
	const { candidateId } = useCandidateRedux()
	const [edit, setEdit] = useState(false)
	const [value, setValue] = useState(dayjs(date, "D-M-YYYY hh:mm"))
	const [disabled, setDisabled] = useState(false)
	const { refresh } = useRefreshCandidate()

	const success = () => {
		refresh()
	}
	const end = () => {
		setDisabled(false)
	}

	const { fetch } = useApiSend(candidateIdPut, { success, end })
	const handleFetch = useCallback(() => {
		setDisabled(true)
		fetch(candidateId, { [id]: value })
	}, [fetch, candidateId, id, value])

	if (!date) return null

	let button = (
		<Button onClick={() => setEdit(true)}>
			<EditIcon />
		</Button>
	)
	if (edit) {
		button = (
			<Button onClick={handleFetch} disabled={disabled}>
				<CheckBoxIcon />
			</Button>
		)
	}

	return (
		<Stack spacing={2} direction={"row"} alignItems={"center"}>
			<InputDateTime {...{ label, value }} disabled={!edit} onChange={setValue} />
			{button}
		</Stack>
	)
}

export const CandidateEditDateTimeDialog = ({ id, label, date, open, setOpen }) => {
	const { candidateId } = useCandidateRedux()
	const [value, setValue] = useState(dayjs(date, "D-M-YYYY hh:mm"))
	const [disabled, setDisabled] = useState(false)
	const { refresh } = useRefreshCandidate()
	useEffect(() => {
		setValue(dayjs(date, "D-M-YYYY hh:mm"))
	}, [date])

	const success = () => {
		refresh()
	}
	const end = () => {
		setDisabled(false)
	}

	const { fetch } = useApiSend(candidateIdPut, { success, end })
	const handleSubmit = useCallback(() => {
		setDisabled(true)
		fetch(candidateId, { [id]: value })
	}, [fetch, candidateId, id, value])

	return (
		<DialogMaster
			{...{
				setOpen,
				title: "editar fecha entrevista",
				open,
				maxWidth: "sm",
				handleSubmit,
				disabled,
			}}
		>
			<InputDateTime {...{ label, value }} onChange={setValue} />
		</DialogMaster>
	)
}
